import React from 'react';
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Board} from "../board/Board";
import {Rack} from "../rack/Rack";
import {Player, selectBoardSizeNonzero, selectRackContents, swipeRotateTile} from "./gameSlice";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import GameParametersPicker from "../GameParametersPicker";
import {CustomGesture, moves} from 'react-touch';

const GESTURES = {
    rotateClockwise1: [
        moves.DOWNLEFT,
        moves.LEFT,
        moves.UPLEFT,
    ],
    rotateClockwise2: [
        moves.UPRIGHT,
        moves.RIGHT,
        moves.DOWNRIGHT,
    ],
    rotateAnticlockwise1: [
        moves.DOWNRIGHT,
        moves.RIGHT,
        moves.UPRIGHT,
    ],
    rotateAnticlockwise2: [
        moves.UPLEFT,
        moves.LEFT,
        moves.DOWNLEFT,
    ],
    flipVertical1: [
        moves.LEFT,
        moves.RIGHT
    ],
    flipVertical2: [
        moves.RIGHT,
        moves.LEFT
    ],
    flipHorizontal1: [
        moves.UP,
        moves.DOWN,
    ],
    flipHorizontal2: [
        moves.DOWN,
        moves.UP,
    ]
}

function Game() {
    const racks = useAppSelector(selectRackContents);
    const showBoard = useAppSelector(selectBoardSizeNonzero);
    const dispatch = useAppDispatch();

  return (
      <CustomGesture config={GESTURES.flipHorizontal1} onGesture={() => dispatch(swipeRotateTile("flipHorizontal"))}>
      <CustomGesture config={GESTURES.flipHorizontal2} onGesture={() => dispatch(swipeRotateTile("flipHorizontal"))}>
      <CustomGesture config={GESTURES.flipVertical1} onGesture={() => dispatch(swipeRotateTile("flipVertical"))}>
      <CustomGesture config={GESTURES.flipVertical2} onGesture={() => dispatch(swipeRotateTile("flipVertical"))}>
      <CustomGesture config={GESTURES.rotateAnticlockwise1} onGesture={() => dispatch(swipeRotateTile("rotateAnticlockwise"))}>
      <CustomGesture config={GESTURES.rotateAnticlockwise2} onGesture={() => dispatch(swipeRotateTile("rotateAnticlockwise"))}>
      <CustomGesture config={GESTURES.rotateClockwise1} onGesture={() => dispatch(swipeRotateTile("rotateClockwise"))}>
      <CustomGesture config={GESTURES.rotateClockwise2} onGesture={() => dispatch(swipeRotateTile("rotateClockwise"))}>
        <div className="App">
            <DndProvider backend={HTML5Backend}>
                { showBoard && <Board /> }
                { racks && racks.map((row, player) => <Rack key={player} player={player as Player} />) }
                <GameParametersPicker/>
            </DndProvider>
        </div>
      </CustomGesture>
      </CustomGesture>
      </CustomGesture>
      </CustomGesture>
      </CustomGesture>
      </CustomGesture>
      </CustomGesture>
      </CustomGesture>
  );
}

export default Game;
